import { SCROLL_DISABLE_CLASSNAME } from "../theme/globalStyles/globalStyles";

var disableScroll = function disableScroll(state) {
  var body = document.querySelector("body");
  var action = "toggle";

  if (state === true) {
    action = "add";
  }

  if (state === false) {
    action = "remove";
  }

  if (body) {
    body.classList[action](SCROLL_DISABLE_CLASSNAME);
  }
};

export default disableScroll;